<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">자재관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
<!--          <el-button type="success" icon="el-icon-document-checked" >엑셀가져오기</el-button>-->
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="8">
            <el-form-item label="제조사" label-width="100px">
              <el-select v-model="form.maker">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['Maker']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="제품군" label-width="100px">
              <el-select v-model="form.itemGroup">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['ModelGroup']"
                    :key="item.id"
                    :value="item"
                    :label="item.value">
                </el-option>
              </el-select>
              <el-select v-model="form.itemDetail" v-if="form.itemGroup != '' && combos['ModelDetail'].length > 0">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['ModelDetail']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="대표모델" label-width="100px">
              <el-input type="text" v-model="form.useModelNm" @keyup.native.enter="goOpen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="품번" label-width="100px">
              <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="기준일자" label-width="100px">
              <el-date-picker type="date" placeholder="기준일자" v-model="form.startDt" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain" style="display: flex">
      <div class="table-sub-contain"  style="width: 100%;">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                ref="gridMain"
                style="width: 100%; height: 54vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsMain"
                :defaultColDef="defaultColDefMain"
                :frameworkComponents="frameworkComponents"
                :rowData="mainData"
                :gridOptions="gridOptionsMain"
                :statusBar="statusBar"
                @cell-value-changed="valueChange"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked"
            />
          </div>
        </div>


        <div class="table-area">
          <div class="table-b">
            <div class="table-header">
              <el-form style="display: grid; float: right;" size="small">
                <el-form-item label-width="120px" label="기준일자">
                  <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt2" value-format="yyyy-MM-dd"></el-date-picker>
                  <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
                  <el-button type="warning" icon="el-icon-document-add" @click="descriptionSave">구분저장</el-button>
                </el-form-item>
              </el-form>
            </div>
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 18vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                @grid-ready="onReadySub"
            />
          </div>
        </div>

      </div> <!-- table sub contain -->
    </div> <!-- table contain -->
  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import common from '@/mixin/common';
import ImgUpload from "@/components/InfoManage/MaterialsMng/ImgUpload";


/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "program",
  components: {ImgUpload},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      parentId: "0",
      form: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
        startDt: this.$moment().add(1, 'days').format('YYYY-MM-DD'),
        startDt2: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
        itemGroup : "",
        itemDetail: "",
      },
      defForm: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
      },
      combos: {
        'Maker': [], //제조사
        'ModelGroup': [], //제품군
        'ModelDetail': [], //제품군 select,
      },
      data: [],
      mainData: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsMain: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefMain: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      programDetail: [],
      gridApi: null,
      columnApi: null,
      gridApiMain: null,
      columnApiMain: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsMain: [],
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      submitList:[],
      modifyList:[],
      selectId: "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      this.gridApiMain = this.gridOptionsMain.api;
      this.columnApiMain = this.gridOptionsMain.columnApi;
      this.gridApiMain.sizeColumnsToFit();
      // this.gridApiMain.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiMain);
      this.init();

      this.$http
          .post("/api/materialsMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            maker: this.form.maker || '',
            itemGroup : this.GroupCheck(this.form.itemDetail),
            useModelNm: this.form.useModelNm || '',
            itemCd: this.form.itemCd || '',
            standDt: this.form.startDt,
            sortType : '',
            page : 1,
            totalPage : 99999,
            totalCount : 1,
            curPage : 0,
            processTime: ""
          })
          .then(response => {
            this.mainData = response.data;
          }).finally(() => {
        this.autoSizeAll(this.gridApiMain);
      });

    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.gridApiSub.sizeColumnsToFit();
      // this.gridApiSub.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    getCheckReadOnly(startDt){
      return startDt == null ? true : false;
    },
    getCheckImgUpload(params){
      let val = "";
      if(params.attachYn === 'N'){
        val = `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer; @click="excelUpload">등록</div>`;
      }
      else if(params.attachYn === "Y"){
        val = `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">확인</div>`;
      }
      else {
        val = `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer; @click="excelUpload">등록</div>`;
      }
      return  val;
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefsMain = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 50
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: (params) => {
            return {trueValue: 'Y', falseValue: 'N'}
            // return {trueValue: 'Y', falseValue: 'N', disable: vm.getCheckReadOnly(params.data.startDt)}
          }
        },
        {headerName: '이미지', field: 'attachYn' , width: 150, editable: false,
          cellRenderer: (params) => {
            console.log("params ", params)
            return vm.getCheckImgUpload(params.data);
          }
        },
        {headerName: '제조사', field: 'makerNm', width: 150, editable: false},
        {headerName: '제품군', field: 'itemGroup', width: 150, editable: false,
          valueFormatter: (params) => {
            return params.data.itemGroupNm == '' ? params.value : params.data.itemGroupNm
          }
        },
        {headerName: '대표모델', field: 'useModelNm', width: 150, editable: false},
        {headerName: '구분', field: 'description', width: 150, editable: false},
        {headerName: '품번', field: 'itemCd', width: 150, editable: false},
        {headerName: '품명', field: 'itemNm', width: 150, editable: false},
        {headerName: '규격', field: 'itemSpec', width: 50, editable: false},
        {headerName: '이평단가', field: 'unitPrice1', width: 50, editable: false},
        {headerName: '운영단가', field: 'unitPrice2', width: 50, editable: false},
        {headerName: '소비자가', field: 'unitPrice3', width: 50, editable: false},
        {headerName: '기준일자', field: 'startDt', width: 50, editable: false,
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {headerName:'', field:'itemId', hide : true},
        {headerName:'', field:'itemPriceId', hide : true},
        {headerName:'', field:'itemGroup', hide : true},
        {headerName:'', field:'maker', hide : true},
        {headerName:'', field:'unitPrice4', hide : true},
        {headerName:'', field:'unitPrice5', hide : true},
        {headerName:'', field:'unitPrice6', hide : true},
        {headerName:'', field:'unitPrice7', hide : true},
        {headerName:'', field:'unitPrice8', hide : true},
        {headerName:'', field:'unitPrice9', hide : true},
        {headerName:'', field:'unitPrice10', hide : true},
      ];

      this.columnDefsSub = [
        {headerName: '제조사', field: 'makerNm', width: 150, editable: false},
        {headerName: '제품군', field: 'itemGroupNm', width: 150, editable: false},
        {headerName: '대표모델', field: 'useModelNm', width: 150, editable: false},
        {headerName: '*구분', field: 'description', width: 150, editable: true ,headerClass: 'require-column',},
        {headerName: '품번', field: 'itemCd', width: 150, editable: false},
        {headerName: '품명', field: 'itemNm', width: 150, editable: false},
        {headerName: '규격', field: 'itemSpec', width: 50, editable: false},
        {headerName: '*이평단가', field: 'unitPrice1', width: 50, editable: true ,headerClass: 'require-column',},
        {headerName: '*운영단가', field: 'unitPrice2', width: 50, editable: true ,headerClass: 'require-column',},
        {headerName: '*소비자가', field: 'unitPrice3', width: 50, editable: true ,headerClass: 'require-column',},
        {headerName:'', field:'itemId', hide : true},
        {headerName:'', field:'itemGroup', hide : true},
      ];
    },
    //Tree 그리드 SelctionChange 발생
    valueChange(params) {
      this.initSub();
    },
    onSelectionChangedSub(event) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
      this.$http
          .post("/api/program/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            programId: voRow[0].programId,
            processTime: ""
          })
          .then(response => {
            if (response.data[0]) {
              this.programDetail = response.data[0];
            }
          }).finally(() => {
      });
    },
    goOpen() {

      this.$store.commit('loading')
      // list 재실행
      this.$http
          .post("/api/materialsMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            maker: this.form.maker || '',
            itemGroup : this.GroupCheck(this.form.itemDetail),
            useModelNm: this.form.useModelNm || '',
            itemCd: this.form.itemCd || '',
            standDt: this.form.startDt,
            sortType : '',
            page : 1,
            totalPage : 99999,
            totalCount : 1,
            curPage : 0,
            processTime: ""
          })
          .then(response => {
            this.subData = [];
            this.mainData = response.data;
            console.log('this.mainData   ',this.mainData);
          }).finally(() => {
        this.autoSizeAll(this.gridApiMain);
        this.$store.commit('finish');
      });

    },
    GroupCheck(modelCd) {
      let val = "";
      if(modelCd == undefined || modelCd == null || modelCd == ''){
        if(this.form.itemGroup.key != undefined){
          val = this.form.itemGroup.key;
        }
      }else{
        if(this.form.itemDetail != undefined){
          val = this.form.itemDetail;
        }
      }
      return val
    },
    save() {

      const chkDatas = this.$refs.gridMain.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '저장할 자재를 체크하세요.' });
        return false;
      }

      let submitList = [];

      this.subData.forEach(x=>{
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          itemGroup: x.itemGroup,
          description: this.isEmpty(x.description),
          itemCd: x.itemCd,
          itemNm: x.itemNm,
          itemSpec: x.itemSpec,
          useModelNm: x.useModelNm,
          maker: x.maker,
          standDt: this.$moment(this.form.startDt2).format('YYYY-MM-DD 00:00:00'),
          itemPriceId: this.isEmpty(x.itemPriceId) == "" ? 0 : x.itemPriceId,
          unitPrice1: parseInt(x.unitPrice1),
          unitPrice2: parseInt(x.unitPrice2),
          unitPrice3: parseInt(x.unitPrice3),
          unitPrice4: parseInt(x.unitPrice4),
          unitPrice5: parseInt(x.unitPrice5),
          unitPrice6: parseInt(x.unitPrice6),
          unitPrice7: parseInt(x.unitPrice7),
          unitPrice8: parseInt(x.unitPrice8),
          unitPrice9: parseInt(x.unitPrice9),
          unitPrice10: parseInt(x.unitPrice10),
          creatorId: this.$store.state.loginInfo.id,
          processTime: ""
        });
      });

      this.$http.put('/api/materialsMng/standDt/save',submitList)
      .then(response => {
        this.$swal({ type: 'success', text: '수정되었습니다.' });
        this.subData = [];
        this.goOpen();
      })
      .catch(({ message }) => {
        if (message === "Request failed with status code 500") {
          this.$swal({ type: "error", text: "오류가 발생했습니다." });
        }
      });

    },
    descriptionSave(){

      const chkDatas = this.$refs.gridMain.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '구분 저장 할 자재를 체크하세요.' });
        return false;
      }

      let submitList = [];

      this.subData.forEach(x=>{
        submitList.push({
          itemId: x.itemId,
          description: this.isEmpty(x.description)
        });
      });

      this.$http.put('/api/materialsMng/description/save',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '수정되었습니다.' });
            this.subData = [];
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
        });

    },
    saveIdx() {

      let subData = this.$refs.gridSub.rowData;

      try {
        for (var i = 0; subData.length; i++) {
          this.$http
              .put('/api/program/update/idx', {
                companyId: this.$store.state.loginInfo.compCd,
                programId: subData[i].programId,
                programIdx: subData[i].programIdx,
                updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
                processTime: ""
              })
              .then(response => {

              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      } catch (e) {
        this.$swal({
          type: 'error',
          text: '오류가 발생했습니다.'
        })
      }
      this.$swal({type: 'success', text: '수정되었습니다.'});
      this.goOpen();

    },
    //그리드 Cell 클릭 함수
    onCellClicked(event) {
      const idx = event.rowIndex;
      const field = event.colDef.field;
      const srcId2 = event.data.itemId;
      const srcId3 = event.data.itemGroup;
      const attachYn = event.data.attachYn;

      console.log(event.data);

      let vm = this;

      if(field == 'attachYn') {
        this.$modal.open({
          width: 800,
          component: ImgUpload,
          parent: this,
          props: {
              srcId2 : srcId2,
              srcId3 : srcId3,
              attachYn : attachYn
          },
          events: {
            close(param) {
              //vm.form.maker = param.data.maker /** 제조사 */
              vm.goOpen();
            },
          }
        });
      }

    },

    deleteRow() {

      const grid = this.$refs.gridMain.rowData
      const programId = grid[0].programId;

      this.$swal({
        type: 'info',
        text: `선택한 프로그램을 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.delete(_url('/api/program/delete/' + this.$store.state.loginInfo.compCd  +'/'  + programId + '/' +this.$store.state.loginInfo.id ),
              {
                process_time: ""
              }).then(response => {
            if (response.data) {
              this.$swal({type: 'info', text: '삭제 완료 하였습니다.'});
            }
            this.goOpen();
          })
              .catch(({message}) => {
                console.error(message);
              }).finally(() => {
            this.$store.commit('finish')
          })
        }
      })

    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    addRow() {
      this.data.push({
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    initSub() {
        const grid = this.$refs.gridMain;

        this.submitList = [];

        const chkDatas = grid.rowData.filter((x,i) => {
          return x.regYn === "Y"
        })

        for(var i=0; chkDatas.length > i; i++){
          // if(this.getCheckReadOnly(chkDatas[i].startDt)) continue;
          this.submitList.push({
            companyId: this.$store.state.loginInfo.compCd,
            maker: chkDatas[i].maker,
            makerNm: chkDatas[i].makerNm,
            useModelNm: chkDatas[i].useModelNm,
            description: chkDatas[i].description,
            itemId: chkDatas[i].itemId,
            itemCd: chkDatas[i].itemCd,
            itemNm: chkDatas[i].itemNm,
            itemSpec: chkDatas[i].itemSpec,
            itemGroup: chkDatas[i].itemGroup,
            itemGroupNm: chkDatas[i].itemGroupNm,
            itemPriceId: chkDatas[i].itemPriceId,
            unitPrice1: chkDatas[i].unitPrice1,
            unitPrice2: chkDatas[i].unitPrice2,
            unitPrice3: chkDatas[i].unitPrice3,
            unitPrice4: chkDatas[i].unitPrice4,
            unitPrice5: chkDatas[i].unitPrice5,
            unitPrice6: chkDatas[i].unitPrice6,
            unitPrice7: chkDatas[i].unitPrice7,
            unitPrice8: chkDatas[i].unitPrice8,
            unitPrice9: chkDatas[i].unitPrice9,
            unitPrice10: chkDatas[i].unitPrice10,
            creatorId: this.$store.state.loginInfo.id,
            processTime: ""
          });
        }

        this.subData = this.submitList;


    },
    async init() {
      this.$store.commit('loading');
      let [query, form] = await Promise.all([
        this.$http.post(`/api/materialsMng/init`,{
          parentId: this.form.itemGroup.id
        })
      ]).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });

      this.combos['Maker'] = query.data.maker;
      this.combos['ModelGroup'] = query.data.modelGroup;
      this.combos['ModelDetail'] = query.data.modelDetail;
      // this.form = form.data;
    },
    cancel() {
      // programInfo 초기화
      this.goOpen();
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
      buttonCellRenderer: ButtonCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch:{
    'form.itemGroup'(){
      this.init();
    }
  }
}
</script>